import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'AM',
  name: 'Andrés M.',
  location: 'Ciudad de México',
  role: 'Electricista Residencial',
  quote: '“Me ayudó a organizar mejor mis presupuestos y la guía de cálculo de materiales me resulta muy útil en cada trabajo.”',
  color: 'bg-navy'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  location: 'Bogotá, Colombia',
  role: 'Técnico Industrial',
  quote: '“Los diagramas de motores trifásicos están muy bien explicados y son claros y fáciles de consultar.”',
  color: 'bg-navy'
}, {
  initials: 'LT',
  name: 'Luis T.',
  location: 'Lima, Perú',
  role: 'Contratista',
  quote: '“Me sirvió para repasar conceptos y trabajar con más seguridad. Tener el material en el celular me resulta muy práctico.”',
  color: 'bg-navy'
}, {
  initials: 'MA',
  name: 'Miguel A.',
  location: 'Medellín, Colombia',
  role: 'Mantenimiento',
  quote: '“Los videos de diagnóstico de fallas están explicados de forma sencilla y profesional. Me ayudaron a entender mejor cada paso.”',
  color: 'bg-navy'
}, {
  initials: 'RG',
  name: 'Roberto G.',
  location: 'Buenos Aires, Argentina',
  role: 'Instalador Solar',
  quote: '“La parte de energía solar está muy bien explicada y me sirvió para reforzar conceptos sobre paneles e inversores.”',
  color: 'bg-navy'
}];
export function DetailedTestimonials() {
  return <section className="py-12 md:py-24 px-4 bg-slate-100 relative border-y border-slate-200" data-id="element-64">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-65">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-navy mb-12 md:mb-20" data-id="element-66">
          Lo que dicen los técnicos
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 items-start" data-id="element-67">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded border border-slate-200 shadow-sm flex flex-col relative group hover:shadow-md hover:-translate-y-1 transition-all duration-300" data-id="element-68">
              <div className="absolute -top-4 -right-4 text-slate-100 group-hover:text-electric/20 transition-colors z-0" data-id="element-69">
                <Quote size={60} fill="currentColor" data-id="element-70" />
              </div>
              <div className="relative z-10" data-id="element-71">
                <div className="flex gap-1 mb-6" data-id="element-72">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-electric text-electric" data-id="element-73" />)}
                </div>
                <blockquote className="text-slate-700 font-semibold text-lg md:text-xl leading-relaxed mb-8 flex-1" data-id="element-74">
                  {t.quote}
                </blockquote>
                <div className="flex items-center gap-4 pt-6 border-t border-slate-100" data-id="element-75">
                  <div className={`${t.color} w-12 h-12 rounded flex items-center justify-center text-electric font-black text-xl shrink-0`} data-id="element-76">
                    {t.initials}
                  </div>
                  <div data-id="element-77">
                    <p className="font-black text-navy text-base md:text-lg" data-id="element-78">
                      {t.name}
                    </p>
                    <div className="flex items-center gap-1.5 text-slate-500 font-medium text-xs md:text-sm mt-1" data-id="element-79">
                      <MapPin size={14} className="text-slate-400" data-id="element-80" />
                      <span data-id="element-81">
                        {t.location} | {t.role}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}